module.exports = __webpack_public_path__ + "media/assets/images/logo_cimentos-698c005b10b69b3fea9960459c7c8b47.jpg";